import { render, staticRenderFns } from "./ScoreMatrix.vue?vue&type=template&id=2c6665ea&scoped=true"
import script from "./ScoreMatrix.vue?vue&type=script&lang=js"
export * from "./ScoreMatrix.vue?vue&type=script&lang=js"
import style0 from "./ScoreMatrix.vue?vue&type=style&index=0&id=2c6665ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6665ea",
  null
  
)

export default component.exports